/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */
class HandlerLinkBox {
	constructor() {
		this.sectionLinkBox = document.querySelector('.section-link-box');
		if (this.sectionLinkBox) {
			this.init();
		}
	}

	init() {
		this.buttons = this.sectionLinkBox.querySelectorAll('.btn-item');
		this.activeButton = this.sectionLinkBox.querySelector('.btn-item.active');

		if (this.activeButton) {
			const sectionBg = this.activeButton.getAttribute('data-bg');
			this.sectionLinkBox.style.backgroundColor = sectionBg; // Asignar el color de fondo al box
		}

		this.buttons.forEach((button) => {
			button.addEventListener('click', () => this.handleButtonClick(button));
		});
	}

	handleButtonClick(button) {
		this.buttons.forEach((btn) => btn.classList.remove('active'));
		button.classList.add('active');

		const buttonText = button.textContent.trim();
		const sectionBg = button.getAttribute('data-bg');
		this.sectionLinkBox.style.backgroundColor = sectionBg;

		const linkSections = this.sectionLinkBox.querySelectorAll('[data-links]');

		linkSections.forEach((linkSection) => {
			linkSection.style.display =
				linkSection.getAttribute('data-links') === buttonText ? 'flex' : 'none';
		});
	}
}

export default HandlerLinkBox;
